const COLORAVAILABLE = "#C3CFD9";

const BORDERAVAILABLE = "#808F9D";

const UNAVAILABLECOLOR = "#FBE192";

const BORDERUNAVAILABLE = "#F7C52B";

const SELECTEDCOLOR = "#1AAE9E";

const SELECTEDBORDER = "#0E7D71";

export {
    COLORAVAILABLE, BORDERAVAILABLE, UNAVAILABLECOLOR,
    BORDERUNAVAILABLE, SELECTEDCOLOR, SELECTEDBORDER
};